import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium'
import {connect} from 'react-redux'
import {CSSProperties} from 'react'
import {CampusHeader} from '../Components/CampusHeader'
import {CampusFooter} from '../Components/CampusFooter'
import {CampusProofCard} from '../Components/CampusProofCard'
import {CampusTVitePurchase} from './CampusTVitePurchase'
import {CampusFeedback} from '../FlatPages/CampusFeedback'
import {browserHistory} from 'react-router'
import * as Request from '../tgccRequest'

const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textTransform: 'uppercase',
    backgroundColor:'#E9E6E6',
    margin:'50px auto 0px auto',
    width:'740px',
    borderRadius:'20px'
}


const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
    padding: '15px',
    background: Tgcc.Styles.cardBackground,
    boxShadow: Tgcc.Styles.boxShadow,
}

const woStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '45px',
    letterSpacing: '12px',
    fontWeight: 'lighter',
    textTransform: 'uppercase',
    color: 'rgba(88,88,88,0.8)'
}

const statusStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '25px',
    letterSpacing: '8px',
    fontWeight: 100,
    textTransform: 'uppercase',
    marginBottom: '10px',
    color: 'rgba(88,88,88,0.7)'
    
}

const btnStyle: React.CSSProperties = {
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '28px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    background: 'rgb(103,186,175)',
    padding: '5px 40px',
    boxShadow: Tgcc.Styles.boxShadow,
    marginTop: '5px',
    marginBottom: '10px'
};

const labelStyle: React.CSSProperties = {
    display: 'flex',
    color: Tgcc.Styles.darkTextColor,
    margin: '10px',
    fontSize: '16px',
    flexBasis: '230px',
    fontFamily:'Lulo',
    '@media(max-width:375px)': {
        fontSize:'14px'
    },
    '@media (max-width:320px)': {
        fontSize:'11px'
    }
} 
const codeStyle: React.CSSProperties = {
    display: 'flex',
    backgroundColor: Tgcc.Styles.buttonBackground,
    color: 'black',
    opacity: 0.6,
    fontSize: '16px',
    textAlign: 'center',
    flexBasis: '175px',
    padding: '0 10px',
    fontFamily:'Lulo',
    '@media(max-width:375px)': {
        fontSize:'14px'
    },
    '@media (max-width:320px)': {
        fontSize:'12px'
    }
}

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    width: '400px',
    maxWidth: '90%',
    alignItems: 'center',
    justifyContent:  'center',
    alignContent: 'center',
}

const dashHdrLineR: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const dashHdrLineL: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'Lulo',
    color:'#616060'
}
const createAcc: React.CSSProperties ={
    textAlign:'center',
    marginTop:'-70px'
}


let errorStyle = Object.assign({},Tgcc.Styles.error, {fontSize: '20px'});

class _CampusTVite extends React.Component<Tgcc.BaseProps, any>{
    state = { 
        tvite: null,
        error: null,
        isWaiting: true,
        purchaseCompleted: false
    };

    componentWillMount(){
        var proofId = this.props.location.query.proofId;
        var completed = this.props.location.query.completed;
        var isCompleted = completed !== undefined || completed === null;
        this.setState({purchaseCompleted: isCompleted});
        Request.getTvite(proofId, this.tviteLoaded, this.loadError);
    }
    componentDidMount(){
        var tag = document.getElementById('campusTvite');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    tviteLoaded = (info: Tgcc.TviteInfo) => {
        this.setState({tvite: info, isWaiting: false});
    }

    loadError = (err: string) => {
        this.setState({error: err, isWaiting: false});
        console.log("error loading tvite: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }
    getDashHeader(){ 
        return (
            <div style={createAcc}>
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>{this.state.tvite.proofId}</h1>
                <div style={dashHdrLineL}></div>
            </div>
        )
    }


    render(){
        var completed = this.state.purchaseCompleted;
        var error = this.state.error ? <div style={errorStyle}>{this.state.error}</div> : null;
        var tvite = this.state.tvite;
        var content = null;
        if(tvite){
            content = (
                <div style={wrapperStyle} className="campusTviteBox">
                {this.getDashHeader()}
                    <CampusProofCard proofId={tvite.proofId} />
                    <div style={rowStyle}>
                        <div style={labelStyle}>T-Vite Roster Code:</div>
                        <div style={codeStyle}>{tvite.code}</div>
                    </div>
                    <CampusTVitePurchase tvite={tvite} purchaseComplete={completed}/>
                </div>
            );
        } else {
            content = (
                <div style={wrapperStyle}>
                    <div style={Tgcc.Styles.error}>{this.state.error}</div>
                </div>
            );
            
        }

        return (
            <div>
                <div id='campusTvite'></div>
                <CampusHeader />
                {content}                
                <CampusFooter state={this.props.state} />
            </div>
        )
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state  }
};

export var CampusTVite = connect(mapStateToProps)(Radium(_CampusTVite));